var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alyssa-header-container"},[_c('div',{staticClass:"alyssa-logo-container"},[_c('a',{staticClass:"alyssa-logo-link",attrs:{"href":"/"}},[_c('img',{staticClass:"nav-logo",attrs:{"src":_vm.settings.logoUrl}})])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-home"},[_c('a',{attrs:{"href":"https://aglassofgoldwater.com"}},[_vm._v("BACK TO HOMEPAGE")])])
}]

export { render, staticRenderFns }